/**
 * ApexCharts는 CSS 변수를 읽지 못하므로 tokens.css 값을 여기 복사해 둡니다.
 * tokens.css를 바꾸면 이 파일도 같이 바꾸세요.
 *
 * categorical 순서는 고정입니다 (순위가 아니라 항목에 색을 붙입니다).
 * dataviz 검증 스크립트로 확인: lightness·chroma·CVD·normal-vision 모두 PASS.
 * 2·3·4번은 대비가 3:1 미만이므로 항상 범례 또는 표와 함께 씁니다.
 */
export const chartTheme = {
  primary: '#0052ff',
  track: '#eef0f3',
  grid: '#dee1e6',
  ink: '#0a0b0d',
  body: '#5b616e',
  muted: '#7c828a',
  surface: '#ffffff',
  success: '#05b169',
  danger: '#cf202f',
  categorical: ['#0052ff', '#eb6834', '#1baf7a', '#eda100'],
} as const;
